import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
var __maxRandomnessOffset = 2;
var __roughness = 1;
var __bowing = 0.85;
var __curveTightness = 0;
var __curveStepCount = 9;

var Wires =
/*#__PURE__*/
function () {
  function Wires() {
    _classCallCheck(this, Wires);
  }

  _createClass(Wires, [{
    key: "_svgNode",
    value: function _svgNode(tagName, attributes) {
      var n = document.createElementNS("http://www.w3.org/2000/svg", tagName);

      if (attributes) {
        for (var p in attributes) {
          if (attributes.hasOwnProperty(p)) {
            n.setAttributeNS(null, p, attributes[p]);
          }
        }
      }

      return n;
    }
  }, {
    key: "line",
    value: function line(svg, x1, y1, x2, y2) {
      var path = this._line(x1, y1, x2, y2);

      var node = this._svgNode("path", {
        d: path.value
      });

      svg.appendChild(node);
      return node;
    }
  }, {
    key: "rectangle",
    value: function rectangle(svg, x, y, width, height) {
      x = x + 2;
      y = y + 2;
      width = width - 4;
      height = height - 4;

      var path = this._line(x, y, x + width, y);

      path = this._line(x + width, y, x + width, y + height, path);
      path = this._line(x + width, y + height, x, y + height, path);
      path = this._line(x, y + height, x, y, path);

      var node = this._svgNode("path", {
        d: path.value
      });

      svg.appendChild(node);
      return node;
    }
  }, {
    key: "polygon",
    value: function polygon(svg, vertices) {
      var path = null;
      var vCount = vertices.length;

      if (vCount > 2) {
        for (var i = 0; i < 2; i++) {
          var move = true;

          for (var _i = 1; _i < vCount; _i++) {
            path = this._continuousLine(vertices[_i - 1][0], vertices[_i - 1][1], vertices[_i][0], vertices[_i][1], move, _i > 0, path);
            move = false;
          }

          path = this._continuousLine(vertices[vCount - 1][0], vertices[vCount - 1][1], vertices[0][0], vertices[0][1], move, i > 0, path);
        }
      } else if (vCount == 2) {
        path = this._line(vertices[0][0], vertices[0][1], vertices[1][0], vertices[1][1]);
      } else {
        path = new WiresPath();
      }

      var node = this._svgNode("path", {
        d: path.value
      });

      svg.appendChild(node);
      return node;
    }
  }, {
    key: "ellipse",
    value: function ellipse(svg, x, y, width, height) {
      width = Math.max(width > 10 ? width - 4 : width - 1, 1);
      height = Math.max(height > 10 ? height - 4 : height - 1, 1);
      var ellipseInc = Math.PI * 2 / __curveStepCount;
      var rx = Math.abs(width / 2);
      var ry = Math.abs(height / 2);
      rx += this._getOffset(-rx * 0.05, rx * 0.05);
      ry += this._getOffset(-ry * 0.05, ry * 0.05);

      var path = this._ellipse(ellipseInc, x, y, rx, ry, 1, ellipseInc * this._getOffset(0.1, this._getOffset(0.4, 1)));

      path = this._ellipse(ellipseInc, x, y, rx, ry, 1.5, 0, path);

      var node = this._svgNode("path", {
        d: path.value
      });

      svg.appendChild(node);
      return node;
    }
  }, {
    key: "_ellipse",
    value: function _ellipse(ellipseInc, cx, cy, rx, ry, offset, overlap, existingPath) {
      var radOffset = this._getOffset(-0.5, 0.5) - Math.PI / 2;
      var points = [];
      points.push([this._getOffset(-offset, offset) + cx + 0.9 * rx * Math.cos(radOffset - ellipseInc), this._getOffset(-offset, offset) + cy + 0.9 * ry * Math.sin(radOffset - ellipseInc)]);

      for (var angle = radOffset; angle < Math.PI * 2 + radOffset - 0.01; angle = angle + ellipseInc) {
        points.push([this._getOffset(-offset, offset) + cx + rx * Math.cos(angle), this._getOffset(-offset, offset) + cy + ry * Math.sin(angle)]);
      }

      points.push([this._getOffset(-offset, offset) + cx + rx * Math.cos(radOffset + Math.PI * 2 + overlap * 0.5), this._getOffset(-offset, offset) + cy + ry * Math.sin(radOffset + Math.PI * 2 + overlap * 0.5)]);
      points.push([this._getOffset(-offset, offset) + cx + 0.98 * rx * Math.cos(radOffset + overlap), this._getOffset(-offset, offset) + cy + 0.98 * ry * Math.sin(radOffset + overlap)]);
      points.push([this._getOffset(-offset, offset) + cx + 0.9 * rx * Math.cos(radOffset + overlap * 0.5), this._getOffset(-offset, offset) + cy + 0.9 * ry * Math.sin(radOffset + overlap * 0.5)]);
      return this._curve(points, existingPath);
    }
  }, {
    key: "_getOffset",
    value: function _getOffset(min, max) {
      return __roughness * (Math.random() * (max - min) + min);
    }
  }, {
    key: "_line",
    value: function _line(x1, y1, x2, y2, existingPath) {
      var lengthSq = Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
      var offset = __maxRandomnessOffset || 0;

      if (offset * offset * 100 > lengthSq) {
        offset = Math.sqrt(lengthSq) / 10;
      }

      var halfOffset = offset / 2;
      var divergePoint = 0.2 + Math.random() * 0.2;
      var midDispX = __bowing * __maxRandomnessOffset * (y2 - y1) / 200;
      var midDispY = __bowing * __maxRandomnessOffset * (x1 - x2) / 200;
      midDispX = this._getOffset(-midDispX, midDispX);
      midDispY = this._getOffset(-midDispY, midDispY);
      var path = existingPath || new WiresPath();
      path.moveTo(x1 + this._getOffset(-offset, offset), y1 + this._getOffset(-offset, offset));
      path.bcurveTo(midDispX + x1 + (x2 - x1) * divergePoint + this._getOffset(-offset, offset), midDispY + y1 + (y2 - y1) * divergePoint + this._getOffset(-offset, offset), midDispX + x1 + 2 * (x2 - x1) * divergePoint + this._getOffset(-offset, offset), midDispY + y1 + 2 * (y2 - y1) * divergePoint + this._getOffset(-offset, offset), x2 + this._getOffset(-offset, offset), y2 + this._getOffset(-offset, offset));
      path.moveTo(x1 + this._getOffset(-halfOffset, halfOffset), y1 + this._getOffset(-halfOffset, halfOffset));
      path.bcurveTo(midDispX + x1 + (x2 - x1) * divergePoint + this._getOffset(-halfOffset, halfOffset), midDispY + y1 + (y2 - y1) * divergePoint + this._getOffset(-halfOffset, halfOffset), midDispX + x1 + 2 * (x2 - x1) * divergePoint + this._getOffset(-halfOffset, halfOffset), midDispY + y1 + 2 * (y2 - y1) * divergePoint + this._getOffset(-halfOffset, halfOffset), x2 + this._getOffset(-halfOffset, halfOffset), y2 + this._getOffset(-halfOffset, halfOffset));
      return path;
    }
  }, {
    key: "_continuousLine",
    value: function _continuousLine(x1, y1, x2, y2, move, overwrite, path) {
      path = path || new WiresPath();
      var lengthSq = Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2);
      var offset = __maxRandomnessOffset || 0;

      if (offset * offset * 100 > lengthSq) {
        offset = Math.sqrt(lengthSq) / 10;
      }

      var halfOffset = offset / 2;
      var divergePoint = 0.2 + Math.random() * 0.2;
      var midDispX = __bowing * __maxRandomnessOffset * (y2 - y1) / 200;
      var midDispY = __bowing * __maxRandomnessOffset * (x1, x2) / 200;
      midDispX = this._getOffset(-midDispX, midDispX);
      midDispY = this._getOffset(-midDispY, midDispY);

      if (move) {
        path.moveTo(x1 + this._getOffset(-offset, offset), y1 + this._getOffset(-offset, offset));
      }

      if (!overwrite) {
        path.bcurveTo(midDispX + x1 + (x2 - x1) * divergePoint + this._getOffset(-offset, offset), midDispY + y1 + (y2 - y1) * divergePoint + this._getOffset(-offset, offset), midDispX + x1 + 2 * (x2 - x1) * divergePoint + this._getOffset(-offset, offset), midDispY + y1 + 2 * (y2 - y1) * divergePoint + this._getOffset(-offset, offset), x2 + this._getOffset(-offset, offset), y2 + this._getOffset(-offset, offset));
      } else {
        path.bcurveTo(midDispX + x1 + (x2 - x1) * divergePoint + this._getOffset(-halfOffset, halfOffset), midDispY + y1 + (y2 - y1) * divergePoint + this._getOffset(-halfOffset, halfOffset), midDispX + x1 + 2 * (x2 - x1) * divergePoint + this._getOffset(-halfOffset, halfOffset), midDispY + y1 + 2 * (y2 - y1) * divergePoint + this._getOffset(-halfOffset, halfOffset), x2 + this._getOffset(-halfOffset, halfOffset), y2 + this._getOffset(-halfOffset, halfOffset));
      }

      return path;
    }
  }, {
    key: "_curve",
    value: function _curve(vertArray, existingPath) {
      var vertArrayLength = vertArray.length;
      var path = existingPath || new WiresPath();

      if (vertArrayLength > 3) {
        var b = [];
        var s = 1 - __curveTightness;
        path.moveTo(vertArray[1][0], vertArray[1][1]);

        for (var i = 1; i + 2 < vertArrayLength; i++) {
          var cachedVertArray = vertArray[i];
          b[0] = [cachedVertArray[0], cachedVertArray[1]];
          b[1] = [cachedVertArray[0] + (s * vertArray[i + 1][0] - s * vertArray[i - 1][0]) / 6, cachedVertArray[1] + (s * vertArray[i + 1][1] - s * vertArray[i - 1][1]) / 6];
          b[2] = [vertArray[i + 1][0] + (s * vertArray[i][0] - s * vertArray[i + 2][0]) / 6, vertArray[i + 1][1] + (s * vertArray[i][1] - s * vertArray[i + 2][1]) / 6];
          b[3] = [vertArray[i + 1][0], vertArray[i + 1][1]];
          path.bcurveTo(b[1][0], b[1][1], b[2][0], b[2][1], b[3][0], b[3][1]);
        }
      } else if (vertArrayLength === 3) {
        path.moveTo(vertArray[0][0], vertArray[0][1]);
        path.bcurveTo(vertArray[1][0], vertArray[1][1], vertArray[2][0], vertArray[2][1], vertArray[2][0], vertArray[2][1]);
      } else if (vertArrayLength == 2) {
        path = this._line(vertArray[0][0], vertArray[0][1], vertArray[1][0], vertArray[1][1], path);
      }

      return path;
    }
  }]);

  return Wires;
}();

var WiresPath =
/*#__PURE__*/
function () {
  function WiresPath() {
    _classCallCheck(this, WiresPath);

    this.p = "";
  }

  _createClass(WiresPath, [{
    key: "moveTo",
    value: function moveTo(x, y) {
      this.p += "M " + x + " " + y + " ";
    }
  }, {
    key: "bcurveTo",
    value: function bcurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
      this.p += "C " + cp1x + " " + cp1y + ", " + cp2x + " " + cp2y + ", " + x + " " + y + " ";
    }
  }, {
    key: "value",
    get: function get() {
      return this.p.trim();
    }
  }]);

  return WiresPath;
}();

export var wired = new Wires();